// extracted by mini-css-extract-plugin
var _1 = "FormInlineNotifications-moduleformInlineNotifications__Q3KEy NotificationInlineList-moduleNotificationInlineList__oSNpf";
export { _1 as "formInlineNotifications" }
